import { Layout } from '@roc/feature-app-core';
import { Button, Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Box } from '@material-ui/core';
import { TierSettingsDialog } from './tierSettingsDialog';
import { TierAssignmentGrid } from './tierAssignmentGrid';

const TABS = [
  { label: 'Tier Assignment' },
  { label: 'Funding Volume' },
];

export const CreditPullTiersManagement = observer(() => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [tierSettingsOpen, setTierSettingsOpen] = useState(false);

  const onTabChange = (e, index) => setSelectedTab(index);

  return (
    <Layout title="Credit Pull Tiers Management">
      <Tabs
        tabs={TABS}
        selectedTab={selectedTab}
        onTabChange={onTabChange}
        right={
          <Box py={1} pr={2}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => setTierSettingsOpen(true)}
              testId="tierSettingsButton"
            >
              Tier Settings
            </Button>
          </Box>
        }
      />
      {selectedTab === 0 && (
        <TierAssignmentGrid />
      )}
      {selectedTab === 1 && (
        <></>
      )}
      <TierSettingsDialog
        open={tierSettingsOpen}
        onClose={() => setTierSettingsOpen(false)}
      />
    </Layout>
  );
});
